import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    currentRouteKey: '',
    apiPendingRequests: 0,
}

export const commonSlice = createSlice({
    name: 'base/common',
    initialState,
    reducers: {
        setCurrentRouteKey: (state, action) => {
            state.currentRouteKey = action.payload
        },
        incrementApiPendingRequests: (state) => {
            state.apiPendingRequests += 1
        },
        decrementApiPendingRequests: (state) => {
            state.apiPendingRequests = Math.max(0, state.apiPendingRequests - 1)
        },
    },
})

export const {
    setCurrentRouteKey,
    incrementApiPendingRequests,
    decrementApiPendingRequests,
} = commonSlice.actions

export default commonSlice.reducer
